export function passwordByteLength(value) {
  const stringValue = String(value || "");
  try {
    return new TextEncoder().encode(stringValue).length;
  } catch {
    return new Blob([stringValue]).size;
  }
}

export function validateNewPassword(password, confirmPassword) {
  if (String(password || "").length < 12) return "password_short";
  if (passwordByteLength(password) > 72) return "password_long";
  if (password !== confirmPassword) return "password_mismatch";
  return null;
}

export function validateAccountForm({ email, password, confirmPassword, mode }) {
  const normalizedEmail = String(email || "").trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) return "email";
  const passwordError = validateNewPassword(
    password,
    mode === "register" ? confirmPassword : password,
  );
  if (passwordError) return passwordError;
  return null;
}
